import { authApi } from 'api';
import { TokenResponse } from '../../unauth/auth/dtos';
import { PublicLoginRequest } from './dtos';

export const publicAccountLogin = async (data: PublicLoginRequest) => {
  return authApi.post<TokenResponse>(undefined, `/auth/login/public/${data.businessId}`);
};

export const logoutAll = async () => {
  return authApi.post<void>(undefined, '/auth/logout/all');
};
